const PY = require('pinyin-pro')
const Staff = require('@/tbs/model/to/Staff')
const staff = new Staff

/**
 * The Staff class acts as the view object for the staff.
 */
const tbs_model_vo_StaffInMatch = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_StaffInMatch.prototype = {
    /* The view object name */
    name: 'staff',
    /* The view object instance */
    view: {
        query: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'GetCrmAccountContactList',
            basePath: 'data.list',
            rule: {
                id: 'id',
                name: 'name',
                logoUrl: 'avatar',
                role: '$roleIds',
                roleLabel: '$roleIds',
                remark: 'remark',
                isLogon: '$userId',
                firstLetter: '$name',
            }
        }
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderFirstLetter: function(name) {
        const firstChar = name.substr(0, 1)
        const firstLetter = PY.pinyin(firstChar, { pattern: 'first', toneType: 'none' })
        console.log('renderFirstLetter', name, firstLetter)
        return firstLetter
    },
    renderIsLogon: function(userId) {
        return userId ? true : false
    },
    renderRole: function(roleIds) {
        if (roleIds.indexOf('1') > -1) {
            return '1'
        }
        else if (roleIds.indexOf('2') > -1) {
            return '1'
        }
        else if (roleIds.indexOf('4') > -1) {
            return '2'
        }
    },
    renderRoleLabel: function(roleIds) {
        let staffRole
        if (roleIds.indexOf('1') > -1) {
            staffRole = 0
        }
        else if (roleIds.indexOf('2') > -1) {
            staffRole = 1
        }
        else if (roleIds.indexOf('4') > -1) {
            staffRole = 2
        }
        return staff.localeProp('role-option-' + staffRole)
    },
}

module.exports = tbs_model_vo_StaffInMatch